module.exports = __webpack_public_path__ + "static/media/choithramsAlmondsS.5f026b92.png";